import React, { useState } from "react";

/**
 * Tooltip mit zwei Modi:
 *   - Default (kurzes Label): `whitespace-nowrap`, öffnet nach oben (z.B. für
 *     Icon-Tooltips in dichten Toolbars).
 *   - `wide` (mehrzeiliger Hilfetext): öffnet nach UNTEN mit fixer Breite und
 *     ordentlichem Padding, damit der Text nicht am Viewport-Rand abgeschnitten
 *     oder ins Niemandsland gequetscht wird.
 */
export default function Tooltip({ content, children, className = "", wide = false }) {
  const [visible, setVisible] = useState(false);

  if (!content) return children;

  const positionClass = wide
    ? "top-full left-0 mt-2"
    : "bottom-full left-1/2 -translate-x-1/2 mb-2";

  const contentClass = wide
    ? "w-80 whitespace-normal leading-relaxed px-4 py-3 text-sm"
    : "whitespace-nowrap px-3 py-1.5 text-xs";

  return (
    <div
      className={`relative inline-flex ${className}`}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && (
        <div className={`absolute ${positionClass} z-50 pointer-events-none`}>
          <div
            className={`glass-card-elevated rounded-lg text-on-surface shadow-xl ${contentClass}`}
          >
            {content}
          </div>
        </div>
      )}
    </div>
  );
}
